module.exports = "<div>\n  <v-list>\n    <template v-for=\"(item,index) in menus\">\n      <v-list-tile :key=\"index\" ripple :to=\"item.path\" exact active-class=\"turquoise primaryDark--text\">\n        <v-list-tile-content :class=\"[$route.path === item.path ? 'body-2 font-weight-bold' : 'body-1']\">\n          <v-list-tile-title>{{item.text}} {{getTotal(item)}}</v-list-tile-title>\n        </v-list-tile-content>\n      </v-list-tile>\n      <v-divider/>\n    </template>\n  </v-list>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/service-book/components/sidebarDetails/template.html
// module id = flKw
// module chunks = 0